import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGroupCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { XFlowNodeCommands } from '../constant';
export var NsDelGroup;
(function (NsDelGroup) {
    /** Command: 用于注册named factory */
    NsDelGroup.command = XFlowGroupCommands.DEL_GROUP;
    /** hookName */
    NsDelGroup.hookKey = 'delGroup';
})(NsDelGroup || (NsDelGroup = {}));
let DelGroupCommand = 
/** 创建节点命令 */
class DelGroupCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.delGroup.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                const { nodeConfig, commandService, deleteService: deleteGroupService } = handlerArgs;
                const { id } = nodeConfig;
                const node = graph.getCellById(id);
                if (deleteGroupService) {
                    const canDel = yield deleteGroupService(handlerArgs);
                    if (!canDel)
                        return { err: 'service rejected' };
                }
                if (!node) {
                    return { err: 'target node is not exist' };
                }
                // 不是Group的节点不能解散
                if (node.getProp('isGroup') !== true) {
                    return { err: 'target node is not group' };
                }
                const { isCollapsed } = node.getData();
                if (isCollapsed) {
                    yield commandService.executeCommand(XFlowGroupCommands.COLLAPSE_GROUP.id, {
                        nodeId: node.id,
                        isCollapsed: false,
                        collapsedSize: { width: 0, height: 0 },
                    });
                }
                const childrens = node.getChildren();
                if (childrens) {
                    childrens.forEach(child => {
                        node.unembed(child);
                        child.prop('group', '');
                        child.setData(Object.assign(Object.assign({}, child.getData()), { group: '' }));
                    });
                }
                yield commandService.executeCommand(XFlowNodeCommands.DEL_NODE.id, {
                    nodeConfig,
                });
                /** add undo: delete node */
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    commandService.executeCommand(XFlowGroupCommands.ADD_GROUP.id, {
                        nodeConfig,
                    });
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], DelGroupCommand.prototype, "contextProvider", void 0);
DelGroupCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsDelGroup.command.id },
    })
    /** 创建节点命令 */
], DelGroupCommand);
export { DelGroupCommand };
//# sourceMappingURL=group-del.js.map